
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { trackLeadLink } from '@/utils/metaPixel'

export default defineComponent({
  name: 'ContactButton',
  props: {
    contentName: {
      type: String,
      default: 'mt_shop_advantages_contact',
    },
  },
  setup() {
    const { t } = useI18n()
    return { t }
  },
  methods: {
    onLeadClick(event: MouseEvent) {
      trackLeadLink(event, 'https://t.me/MT_SHOP_Support', {
        contentName: this.contentName,
        contentCategory: 'mt_shop_lead_button',
      })
    },
  },
})
